export const h = {
	login:{
			login:"Se connecter",
			pleaseusername:"veuillez entrer le nom d'utilisateur",
			pleasepassword:"Veuillez entrer le mot de passe",
			checkname:"Veuillez entrer le nom d'utilisateur correct",
			checkpass:"Le mot de passe ne peut pas contenir moins de 3 caractères",
		},

	navbar:{
		home:"page de garde",
		mycenter:"Centre personnel",
		outlogin:"quitter",
		close:"fermeture",
		editLanguage:"langue d'édition",
	},
	vip:{
    ywy:"opérationnel",
		nickname:"Surnom",
		pleasenickname:"Veuillez entrer un pseudo",
		username:"nom d'utilisateur",
		pleaseusername:"veuillez entrer le nom d'utilisateur",
		arealogin:"Espace de connexion",
		pleasearealogin:"Veuillez entrer votre espace de connexion",
		nationality:"Pays de citoyenneté",
		pleasenationality:"Veuillez sélectionner la nationalité",
		depositstatus:"Statut du dépôt",
		pleasedepositstatus:"Veuillez sélectionner le statut du dépôt",
		createtime:"temps de creation",
		logintime:"Heure de connexion",
		startime:"Heure de départ",
		endtime:"Heure de fin",
		no:"numéro de série",
		shangji:"Recommandation directe aux supérieurs",
		keyongmoney:"Solde disponible",
		baozhengjing:"marge",
		fudongyingkui:"Gains et pertes flottants",
		zicantotal:"Actif total",
		yaoqingma:"Code d'invitation",
		zongrujing:"dépôt total",
		zongchujing:"Total des retraits",
		loginIp:"adresse IP de connexion",
		zuihoulogin:"heure de la dernière connexion",
		shoucirujingmoney:"Montant du premier dépôt",
		shoucirujingtime:"Heure du premier dépôt",
		kaitongtime:"Horaire d'ouverture",
		keyong:"Disponible",
		daoshi:"tuteur",
		dongjie:"geler",
		chujingstate:"Statut de retrait",
		xiajichujingstate:"Statut de retrait de niveau inférieur",
		caozuo:"fonctionner",
		chakan:"Vérifier",
		heji:"total",
		moneytotal:"solde total",
		paixu:"trier",
		daochu:"Exporter",
		huiyuanguanli:"Gestion des membres",
		yonghu:"utilisateur",
		search:"Recherche de requête",
		reset:"réinitialiser",
		delete:"supprimer",
		kickout:"expulser",
		notlogin:"Pas connecté",
		editLanguage:"langue d'édition",
		yourujing:"Il y a un dépôt",
		wurujing:"Pas de dépôt",
    todayreg: "Volume d'inscription du jour : ",
    newvipnum: "Le nombre de nouveaux membres VIP rejoignant : ",
    juese: "rôle",
    xiugaimima: "modifier le mot de passe",
    jiumima: "ancien mot de passe",
    shurujiumima: "veuillez entrer l'ancien mot de passe",
    xinmima: "nouveau mot de passe",
    shuruxinmima: "veuillez entrer le nouveau mot de passe",
    gerenzhongxing: "centre personnel",
    yonghuxinxi: "informations utilisateur",
	remark: "commentaires",
	},
	info:{
		home:"Page d'accueil",
		user:"ID de l'utilisateur",
		nickname:"Surnom",
		account:"compte",
		identity:"Numéro d'identification",
		phone:"numéro de téléphone",
		nationality:"Pays de citoyenneté",
		Balance:"Gestion du solde",
		real:"vrai compte",
		zhongmongy:"solde total",
		keyongmoney:"Solde disponible",
		jiaoyidongjie:"Transaction gelée",
		shishilirun:"profit en temps réel",
		shishikeyong:"Disponible en temps réel",
		xunizhanghu:"compte virtuel",
		churujinguanli:"Gestion des dépôts et retraits",
		chakanzijinjilu:"Afficher l'historique des fonds",
		rujinjilu:"Dossier de dépôt",
		rujinjine:"Montant du dépôt",
		jiaoyibishu:"Nombre de transactions",
		chujinjilu:"Dossiers de retrait",
		chujinjine:"Montant de retrait",
		jiaoyiguanli:"Gestion des transactions",
		lishijilu:"enregistrement de l'histoire",
		chakanlishi:"Afficher les informations historiques sur les transactions",
		jiaoyishoushu:"Lots d'échange",
		jiaoyiyingkui:"Profits et pertes commerciaux",
		dangqianchicang:"Position actuelle",
		chakandangqianchicang:"Afficher les informations sur la position actuelle",
		dangqianguadan:"Commande en attente actuelle",
		chakanguadanliebiao:"Afficher la liste des commandes en attente",
		guadanbishu:"Nombre de commandes en attente",
		yongjinguanli:"Gestion des commissions",
		duanwei:"rang",
		wu:"aucun",
		zhishushangji:"Supérieur immédiat",
		shangjidaili:"Agent supérieur",
		xiajituandui:"Équipe subordonnée",
		shurudailiname:"Veuillez entrer le nom de l'agent",
		chakan:"Vérifier",
		fanyongjie:"Montant du rabais",
		fanyongbishu:"Nombre de rabais",
		chakanyongjinjilu:"Afficher les enregistrements de remise",
		chakanyonghuinfo:"Afficher les détails de l'utilisateur",
		chakanwenjuan:"Voir le questionnaire",
		resetpassword:"réinitialiser le mot de passe",
		sendmsg:"envoyer le message",
		update:"Réviser",
		unbound:"Pas liée",
		weishiming:"N",
		yishiming:"Y",
		shiming:"realname",
		gendan:"Gestion documentaire",
		gensui:"suivre",
		chakangendan:"Afficher les enregistrements de commandes",
		dingdanhao:"numéro de commande",
		shoudongpay:"Recharge manuelle",
		chakanyongjingjilu:"Afficher l'historique des commissions",
		xiugaiyonghuxinxi:"Modifier les informations utilisateur",
		queding:"Bien sûr",
		quxiao:"Annuler",
		email:"Mail",
		selguoji:"Veuillez sélectionner la nationalité",
		sendusermsg:"Envoyer un message à l'utilisateur",
		title:"titre",
		shurutitle:"Veuillez saisir le titre du message",
		content:"contenu",
		shurucontent:"Veuillez saisir le contenu du message",
		zhenshi:"réalité",
		xuni:"virtuel",
		fangxiang:"direction",
		zhanghu:"Compte",
		add:"Augmenter",
		less:"déduire",
		type:"taper",
		guanliyuanpay:"Recharge administrateur",
		pay:"recharger",
		money:"Montant",
		updategdmsg:"Modifier les informations de la commande",
		xinhaoyuan:"source de signal",
		yes:"Oui",
		no:"Non",
		updateyongjingmsg:"Modifier les informations sur les commissions",
		qingxuanzejuese:"Veuillez sélectionner le rôle du compte",
		zuoduo:"Allez-y longtemps",
		zuokong:"court",
		gensuinicheng:"suivre le pseudo",
		kaicangjia:"prix d'ouverture",
		pingcangjia:"Le dernier prix",
		shousu:"La taille du lot",
		pingcangdate:"Date d'ouverture du poste",
		kaicangdate:"Date de clôture",
		chakangensuiinfo:"Afficher les détails du suivi",
		gensuiuserno:"Suivre le numéro d'utilisateur",
		gensuiyonghuname:"Suivre le pseudo de l'utilisateur",
		gensuifangshji:"suivre la méthode",
		number:"quantité",
		danwei:"unité",
		zhengxiang:"avant",
		fanxaing:"inverse",
		beishu:"plusieurs",
		shousu:"La taille du lot",
		gensuizhuangtai:"suivre le statut",
		genjinzhong:"La candidature suit",
		gensuiok:"Accepter d'être suivi",
		gensuino:"Refusé d'être suivi",
		chexiao:"Annuler",
		gensuidate:"suivre le temps",
		chakanlishijiaoyi:"Afficher les informations historiques sur les transactions",
		chakanguadanlist:"Afficher la liste des commandes en attente",
		heyue:"contracter",
		daili:"agissant",
		huiyuanname:"Nom du membre",
		xianjia:"limite de prix",
		zhisun:"arrêter les pertes",
		guadanjia:"prix de la commande en attente",
		zhiyingzhisun:"Prenez des bénéfices et stoppez les pertes",
		zhiyingjia:"Prendre le prix du profit",
		zhiyinghuichejia:"Prendre le prix de retracement des bénéfices",
		zhisunjia:"Prix stop loss",
		zhisunhuichejia:"Prix de retracement stop loss",
		weiset:"pas encore défini",
		zt:"État",
		chakanchicangmsg:"Afficher les informations sur la position actuelle",
		shouyiId:"Identifiant du bénéficiaire",
		xiajiid:"ID utilisateur subordonné",
		xiajiuser:"Nom d'utilisateur subordonné",
		fanyongmonney:"Montant du rabais",
		tuihuibaozhengjing:"Dépôt de retour",
		shouxufei:"frais de gestion",
		shouyi:"revenu",
		lixi:"Intérêt",
		zengmoney:"prime",
		zhuijiabaozhengjing:"appel de marge",
		fanyong:"Rabais",
		rujing:"Dépôt",
		chujing:"Retirer des fonds",
		chujingshibai:"Remboursement si l'examen du retrait échoue",
		guanliyuanless:"Déduction administrative",
		pingzhong:"Variété",
		shengqingzhong:"Candidature",
		wancheng:"Finition",
		chongzhimima:"Réinitialisation du mot de passe réussie",
		copy:"copie",
		zhanghaomima:"mot de passe du compte",
		fenye:"Article/Page",
    tixianmima:"Retirer le mot de passe",
		gong:"commun",
		tiao:"bande",
		ye:"Page",
		goto:"Aller à",
		outtitle:"Vous avez été déconnecté. Vous pouvez annuler et rester sur cette page ou vous reconnecter.",
		outok:"OK pour se déconnecter",
		chongxingdenglu:"réinscrire",
		cancel:"Annuler",
		pingtai:"plate-forme",
		nodata:"Pas de données",
    shangjiID: "ID Supérieur",
    shangjiaccount: "Compte Supérieur",
    shangjiname: "Surnom Supérieur",
    shangjinickname: "Nom Supérieur",
    zhongyingkui: "Profit et Perte Total",
    fuying: "Profit Flottant",
    yue: "Solde",
    sheng: "Ordre Croissant",
    jiang: "Ordre Décroissant"
	},
	history:{
			guadan:"Profit et perte",
			shijia:"commande en cours",
			gendan:"prix du marché",
			dangqianjia:"Suivre les ordres",
			geyelixi:"prix actuel",
			weituodate:"intérêts au jour le jour",
			pingcangfangshi:"Temps de commission",
			dingdanyongjing:"Méthode de clôture",
			shoudongpingcang:"Commission de commande",
			qiangzhipingcang:"Fermeture manuelle",
			gendanpingcang:"Liquidation forcée",
			baocang:"Liquidation",
			yuguqiangpingjia:"Suivre les ordres pour clôturer une position",
			kaicangdiqu:"Prix ​​de parité forcé estimé",
			ispingcang:"Zone d'ouverture",
			tips:"Etes-vous sûr de la liquidation forcée ?",
			pincangsucc:"indice",
			queding:"Position clôturée avec succès",
			cancel:"Bien sûr",
		},

	Langswitch: {
	  "en":"Anglais",
	  "id":"indonésien",
	  "th":"Langue thai",
	  "vi":"vietnamien",
	  "zh":"Chinois",
	  "fa":"Français",
	  "han":"coréen",
	  "tu":"turc",
	  "pu":"Portugais",
	  "xi":"Espagnol",
	  "jp":"Japonais",
	  "ar":"arabe",
	},
}



// WEBPACK FOOTER //
// ./src/i18n/langs/fa.js